import React from 'react';
import styled from 'styled-components';

const Input = styled.input`
  padding: 10px;
  width: 80%;
  font-size: 1rem;
  margin-bottom: 20px;
  border-radius: 8px;
`;

const SearchInput = ({ value, onChange }) => {
  return <Input type="text" placeholder="Pesquise..." value={value} onChange={onChange} />;
};

export default SearchInput;
